<template>
    <div>
        <div class="mx-2  pt-2 ">
            <loading v-model:active="pageLoader" :can-cancel="false" loader="dots" color="#02C782"
                background-color="#818585" width="130" height="130" :is-full-page="true" />
            <div class="flex justify-between mt-10 md:mt-0 items-baseline	">
                <h1 style="font-weight: 550;" class="text-2xl  mb-5 md:mt-10 mt-3">Users</h1>

            </div>
            <div class="qr-code-input flex-wrap flex items-center justify-between md:mb-0 mb-5" v-if="hascanduploadeuser">
                <div class="flex md:w-80 w-full flex-wrap items-baseline mb-5">
                    <label class="block w-[150px]  text-sm text-bg-save font-medium  text-[17px] dark:text-white"
                        for="file_input">Upload
                        Excel</label>
                        
                    <input @change="handleFileUpload"
                        class="block w-full text-sm  text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                        aria-describedby="file_input_help" id="file_input" type="file">
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-300" id="file_input_help"></p>
                <a style="cursor: pointer;" class="text-[#1C64F2] pt-1  underline text-xs  " @click="downloadFile">Download Template</a>
                </div>
                <router-link v-if="hasCnaCreateUser" to="/createusers" style="background: #2E2C72;"
                    class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-regal-blue dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Create
                    User
                </router-link>

            </div>
            <div class="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between  pb-4">
                <div>
                    <!-- @change="fetchShifts" v-model="number"  -->
                    <span class="text-base">
                        show:
                        <select class="rounded-lg" id="quantity" @change="fetchuser('isshowuser')" v-model="number"
                            name="quantity" style="border: 1px solid white; border-top: #F9F9F9;">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                        &nbsp; entries
                    </span>
                </div>
                <form>
                    <label for="default-search"
                        class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
                    <div class="relative">
                        <input type="search" v-model="searchQuery" style="padding-left: 20px; width: 350px; "
                            id="default-search"
                            class="block w-full p-4 pl-10 ps-20 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Search" required>
                        <button type="button" @click.prevent="handlesearch"
                            class="text-white bg-button-blue absolute end-2.5 bottom-2  hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-[10px] py-[12px] dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            <svg style="" class="w-10 h-4  text-white dark:text-gray-400" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg></button>
                    </div>
                </form>
            </div>

            <div class="relative overflow-x-auto overflow-hidden  shadow-md ">
                <table class="w-full text-sm  border text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead class="text-xs text-gray-700  bg-stone-300 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" class="px-6 py-3">
                                Id
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    User Name
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Display Name
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Role
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Working Hospital
                                    <a href="#"></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Other Hospitals
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Created by
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Updated by
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Created at
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Updated at
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3" v-if="hascanUPdatePassword">
                                <span class="flex items-center " >Update Password</span>
                            </th>
                            <th scope="col" class="px-6 py-3" v-if="hascanupdateuser">
                                <span class="flex items-center ">Edit</span>
                            </th>
                            <th scope="col" class="px-6 py-3" v-if="hascandeleteuser">
                                <span class="flex items-center">Delete</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, index) in users" :key="user.id"
                            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                            <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{{
                                calculateSerialNumber(index) }}
                            </td>
                            <td class="px-6 py-4">{{ user?.username }}</td>
                            <td class="px-6 py-4">{{ user?.display_name }}</td>
                            <td class="px-6 py-4">{{ user?.roles[0]?.name }}</td>
                            <td class="px-6 py-4">
                                <span v-if="user?.working_hospital?.name"
                                    class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                    {{ user?.working_hospital?.name }}
                                </span>
                            </td>
                            <td class="px-6 py-4">

                                <span
                                    class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300"
                                    v-for="site in user.hospitals" :key="site.id">{{ site?.name }}</span>
                            </td>
                            <td class="px-6 py-4">{{ user?.created_by?.display_name }}</td>
                            <td class="px-6 py-4">{{ user?.updated_by?.display_name }}</td>
                            <td class="px-6 py-4">{{ user?.created_at }}</td>
                            <td class="px-6 py-4">{{ user?.updated_at }}</td>
                            <td class="px-6 py-4 " v-if="hascanUPdatePassword">
                                <a v-if="adminId !== user.id" style="cursor:pointer" @click="showPopover(index)"
                                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline">
                                    Update Password 
                                </a>
                                <div v-if="showpopoverval[index]" role="tooltip"
                                    class="w-44 z-10   text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm  dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800">
                                    <div
                                        class="px-3 py-2 bg-gray-100 border-b border-gray-200 rounded-t-lg dark:border-gray-600 dark:bg-gray-700">
                                        <h3 class="font-semibold text-gray-900 dark:text-white">Update Password
                                         <span  @click="closePopover" style="float:right;cursor:pointer">&#10060;</span>
                                        </h3>
                                    </div>
                                    <div class="mt-3" >
                                        <form @submit.prevent="submitForm(user.id)" class="mx-auto">
                                            <div class="mb-5">
                                                <input type="password" id="password" v-model="Password"
                                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                    placeholder="•••••••••" required />
                                            </div>
                                            <div class="flex justify-center mb-3">
                                                <button type="submit"
                                                    class="text-white bg-bg-save hover:bg-hover-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>

                                            </div>
                                        </form>
                                    </div>
                                    <div data-popper-arrow></div>
                                </div>
                            </td>
                            <td class="px-6 py-4 " v-if="hascanupdateuser">
                                <router-link :to="'/editUser-' + user.id"
                                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Edit</router-link>
                            </td>
                            <td class="px-6 py-4 " v-if="hascandeleteuser" style="cursor: pointer;">
                                <a @click="delteuser(user.id)" style="color: red;"
                                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Delete</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex justify-end mt-2">
                <vue-awesome-paginate :total-items="totalpage" class="overflow-hidden pl-5" :items-per-page="1"
                    :max-pages-shown="5" v-model="currentPage" :on-click="onClickHandler" :hide-prev-next-when-ends="true"
                    next-button-content=">" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import axiosInstance from "@/plugins/axios"
import Swal from 'sweetalert2';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { useScanCodeStore } from '@/store/QRScanCode';
const qrscancode = useScanCodeStore();
const isLoadingExcel = ref(false);
const pageLoader = ref(false);
const users = ref()
const number = ref(10)
const currentPage = ref(1);
const totalpage = ref()
const searchQuery = ref('');
const isapplys = ref(false)


const showpopoverval = ref([]);

const showPopover = (index) => {
    // Close all other popovers
    showpopoverval.value = showpopoverval.value.map((_, i) => i === index);

    // Toggle the current popover
    showpopoverval.value = [...showpopoverval.value]; // Ensure reactivity
    showpopoverval.value[index] = !showpopoverval.value[index];
};
const closePopover = () => {
    // Close all popovers
    showpopoverval.value = [];
};
const Password = ref()
const submitForm = async (id) => {
    try {
        // Make API request to update password
        const response = await axiosInstance.post('/admin-update-password', {
            password: Password.value,
            user_id: id
        });
        Swal.fire({
            toast: true,
            title: 'Successfully update Password ',
            icon: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
        // Reset form fields after successful password update
        Password.value = '';
        closePopover();
        // Optionally, show a success message to the user
    } catch (error) {
        console.error('Error updating password:', error.response.data.message);
        Swal.fire({
            toast: true,
            title: error.response.data.message,
            icon: 'error',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
    }
};


const calculateSerialNumber = (index) => {
    // Calculate serial number based on page, limit, and index
    if (isapplys.value === true) {
        return index + 1
    }
    if (currentPage.value === 1) {
        return index + 1;
    } else {
        return (currentPage.value - 1) * number.value + index + 1;
    }
};

const handleFileUpload = (event) => {
    const file = event.target.files[0];
    uploadFile(file);
};
function downloadFile() {
      const downloadLink = "http://13.50.122.252:8080/import-templates/users_import_template.xlsx";
      window.open(downloadLink, "_blank");
    }
  
const uploadFile = async (file) => {
    pageLoader.value = true;
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axiosInstance.post('/users/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        pageLoader.value = false;

        Swal.fire({
            icon: 'success',
            title: 'user imported successfully',
            text: ''
        });
    } catch (error) {
        pageLoader.value = false;
        Swal.fire({
            icon: 'warning',
            title: 'user import failed',
            text: error.response.data.message
        });
    }
};

const handleexportexcel = async () => {
    isLoadingExcel.value = true;
    try {
        await qrscancode.getExcelExcelUser(); // Assuming this is an asynchronous function
    } catch (error) {
        console.error('Error exporting Excel:', error);
        // Handle errors as needed
    } finally {
        isLoadingExcel.value = false;
    }
}

const handlesearch = async (e) => {
    await fetchuser('isshowuser');
}
const fetchuser = async (isshowuser) => {
    try {
        if (isshowuser === 'isshowuser') {
            currentPage.value = 1
            const response = await axiosInstance.get(`/users/${number.value}/${searchQuery.value}?page=${currentPage.value}`);
            users.value = response.data.data.users.data
            totalpage.value = response.data.data.users.last_page;
            // console.log( response.data.data.users.data,'valllllllllldddddddll');

        } else {
            const response = await axiosInstance.get(`/users/${number.value}?page=${currentPage.value}`);
            // console.log( response.data.data.users.data,'vallllllllllll');
            users.value = response.data.data.users.data
            totalpage.value = response.data.data.users.last_page;
        }

    } catch (error) {
        console.error('Error fetching district info:', error);
        // Handle error or show error message
    }
}
const onClickHandler = async () => {
    await fetchuser()
    // pagniationpage.value =  true
}
const delteuser = async (id) => {
    const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this shift?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    });
    const response = await axiosInstance.delete(`/users/${id}`);

    if (confirmed.isConfirmed) {
        try {

            Swal.fire(
                'Deleted!',
                'Your user has been deleted.',
                'success'
            );
            fetchuser()
        } catch (error) {
            console.error('Failed to delete user:', error);
            Swal.fire(
                'Error!',
                'Failed to delete user.',
                'error'
            );
        }
    }
};
import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const permissions = ref([])
const adminId = ref()
onMounted(() => {
    const authData = authStore.authData;
    adminId.value = authData?.id
    permissions.value = authStore.authData.permissions

});
const hasCnaCreateUser = computed(() => permissions.value.some(permission => permission.name === 'can create user'));
const hascanupdateuser = computed(() => permissions.value.some(permission => permission.name === 'can update user'));
const hascandeleteuser = computed(() => permissions.value.some(permission => permission.name === 'can delete user'));
const hascanduploadeuser = computed(() => permissions.value.some(permission => permission.name === 'can import users'));
const hascanUPdatePassword = computed(() => permissions.value.some(permission => permission.name === 'can update users password'));

onMounted(async () => {
    await authStore.handlepermission()
})

onUnmounted(async () => {
    await authStore.handlepermission()
})
onMounted(() => {
    fetchuser()
})
</script>